import { Route, Routes } from "react-router-dom";
import { EWCI1001003Q } from "@/tra/tancis/ptli/ewc/svr/EWCI1001003Q";
import { EWCI1001004Q } from "@/tra/tancis/ptli/ewc/svr/EWCI1001004Q";

import { EWCI1001005Q } from "@/tra/tancis/ptli/ewc/svr/EWCI1001005Q";
import { EWCI1001006Q } from "@/tra/tancis/ptli/ewc/svr/EWCI1001006Q";

import { EWCI1001007Q } from "@/tra/tancis/ptli/ewc/svr/EWCI1001007Q";
import { EWCI1001008S } from "@/tra/tancis/ptli/ewc/svr/EWCI1001008S";
import { EWCI1001009S } from "@/tra/tancis/ptli/ewc/svr/EWCI1001009S";
import { EWCI1001011Q } from "../temp/dw/EWCI1001011Q";
import {EWCI9999019Q} from "@/tra/tancis/ptli/temp/dw/EWCI9999019Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const EwcRouter = () => {
    return (
        <Routes>
            <Route path="/svr/ewci1001003q" element={<EWCI1001003Q />} />
            <Route path="/svr/ewci1001004q/:namespace/:name" element={<EWCI1001004Q />} />

            <Route path="/svr/ewci1001005q" element={<EWCI1001005Q />} />
            <Route path="/svr/ewci1001006q/:notiSendUuid" element={<EWCI1001006Q />} />

            <Route path="/altermgr/ewci1001007q" element={<EWCI1001007Q />} />
            <Route path="/altermgr/ewci1001011q" element={<EWCI1001011Q />} />
            <Route path="/altermgr/ewci1001008s/:uid" element={<EWCI1001008S />} />
            <Route path="/altermgr/ewci1001009s/:uid" element={<EWCI1001009S />} />

            <Route path="/altermgr/ewci9999017q" element={<EWCI9999019Q />} />
        </Routes>
    );
};
